module.exports = __webpack_public_path__ + "static/media/image3.83b16390.jpg";